import { render, staticRenderFns } from "./SetDivider.vue?vue&type=template&id=7a4cb30f"
import script from "./SetDivider.vue?vue&type=script&lang=js"
export * from "./SetDivider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports